// extracted by mini-css-extract-plugin
export default {"active":"Im1VW","slide-popup":"QXWll"};